import { Popover, Typography } from '@mui/material';
import styled from 'styled-components';

import { COLORS } from '../../../theme';

export const StyledPopover = styled(Popover)`
  .MuiPaper-root {
    width: auto;
    padding: ${({ theme }) => theme.spacing.m4};
    border: 1px solid ${COLORS.black10};
    border-radius: ${({ theme }) => theme.borderRadius.primary};
    box-shadow: 0px 40px 64px -12px rgba(0, 0, 0, 0.11),
      0px 0px 14px -4px rgba(0, 0, 0, 0.05),
      0px 32px 48px -8px rgba(0, 0, 0, 0.1);
  }
`;

export const Heading = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.spacing.s4} !important;
  color: ${COLORS.black60};
`;

export const Separator = styled.div`
  align-self: center;
  margin: 0 -4px;
  font-size: 36px;
`;

export const TimeContainer = styled.div`
  display: grid;
  grid-template-columns: 78px auto 78px auto;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s3};

  // inputs

  .MuiInputBase-root {
    background-color: ${COLORS.blueLight};
  }

  .MuiInputBase-input {
    height: 60px;
    padding: 0 ${({ theme }) => theme.spacing.s2};
    color: ${COLORS.kinetikBlack};
    font-size: 36px;
    text-align: center;
  }

  .MuiInputBase-root.Mui-focused .MuiInputBase-input {
    color: ${COLORS.kinetikBlue};
  }

  .MuiInputBase-root .MuiOutlinedInput-notchedOutline,
  .MuiInputBase-root:not(.Mui-disabled):not(.Mui-error):hover
    .MuiOutlinedInput-notchedOutline {
    border: 2px solid transparent;
  }

  .MuiInputBase-root:not(.Mui-disabled):not(.Mui-error).Mui-focused
    .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.kinetikBlue};
  }

  // meridiem buttons

  .MuiToggleButtonGroup-root {
    .MuiToggleButton-root.MuiToggleButton-root {
      display: flex;
      justify-content: center;
      height: ${({ theme }) => theme.spacing.l1};
      width: 52px;
      color: ${COLORS.kinetikBlack};
      font-size: ${({ theme }) => theme.fontSize.body1};
      font-weight: 400;
      border: 1px solid transparent;
      border-radius: ${({ theme }) => theme.borderRadius.secondary};

      &:hover {
        color: ${COLORS.kinetikBlue};
        background-color: ${COLORS.blueLight};
        border-color: ${COLORS.kinetikBlue};
      }

      &.Mui-selected {
        color: ${COLORS.white};
        background-color: ${COLORS.kinetikBlue};
      }

      &.Mui-focusVisible {
        color: ${COLORS.white};
        background-color: ${COLORS.kinetikBlueDark};
      }
    }
  }
`;

export const MeridiemContainer = styled.div``;
